var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            { attrs: { cols: "12", lg: "11", xl: "10" } },
            [
              !_vm.isUserAdmin
                ? _c(
                    "v-alert",
                    {
                      staticClass: "mt-8",
                      attrs: { type: "error", outlined: "" },
                    },
                    [
                      _vm._v(
                        " You are not allowed to access background job controls. "
                      ),
                    ]
                  )
                : _c(
                    "v-card",
                    {
                      staticClass: "mt-8 mb-8",
                      attrs: { loading: _vm.loading },
                    },
                    [
                      _c(
                        "template",
                        { slot: "progress" },
                        [
                          _c("v-progress-linear", {
                            attrs: {
                              color: "#006c27",
                              indeterminate: "",
                              height: "6",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-title",
                        { staticClass: "grey--text text--darken-2" },
                        [
                          _vm._v(" Background Jobs "),
                          _c("v-spacer"),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-2",
                              attrs: { color: "#006c27", dark: "" },
                              on: { click: _vm.loadJobs },
                            },
                            [_vm._v("Reload")]
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { text: "", color: "#006c27" },
                              on: { click: _vm.loadAudit },
                            },
                            [_vm._v("Reload Audit")]
                          ),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "v-row",
                            { staticClass: "mb-4", attrs: { align: "center" } },
                            [
                              _c("v-col", { attrs: { cols: "12", md: "8" } }, [
                                _c("div", { staticClass: "text-subtitle-2" }, [
                                  _vm._v("Interval format help"),
                                ]),
                                _c(
                                  "div",
                                  { staticClass: "text-caption grey--text" },
                                  [
                                    _vm._v(" Use "),
                                    _c("code", [_vm._v("@every 5m")]),
                                    _vm._v(
                                      " for duration-based schedules or a fixed-time cron like "
                                    ),
                                    _c("code", [_vm._v("0 2 * * *")]),
                                    _vm._v(". "),
                                  ]
                                ),
                              ]),
                              _c(
                                "v-col",
                                {
                                  staticClass: "d-flex justify-end",
                                  attrs: { cols: "12", md: "4" },
                                },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mr-2",
                                      attrs: {
                                        small: "",
                                        outlined: "",
                                        color: "#006c27",
                                        href: "https://pkg.go.dev/time#ParseDuration",
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(" @every help ")]
                                  ),
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        small: "",
                                        outlined: "",
                                        color: "#006c27",
                                        href: "https://pkg.go.dev/github.com/robfig/cron/v3#hdr-CRON_Expression_Format",
                                        target: "_blank",
                                      },
                                    },
                                    [_vm._v(" cron help ")]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.headers,
                              items: _vm.jobs,
                              loading: _vm.loading,
                              "item-key": "jobId",
                              "items-per-page": 10,
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.enabled`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            small: "",
                                            color: item.enabled
                                              ? "#006c27"
                                              : "#9e9e9e",
                                            dark: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.enabled
                                                  ? "enabled"
                                                  : "disabled"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.running`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "v-chip",
                                        {
                                          attrs: {
                                            small: "",
                                            color: item.running
                                              ? "#f57c00"
                                              : "#757575",
                                            dark: "",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                item.running
                                                  ? "running"
                                                  : "idle"
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.lastRun`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-caption" },
                                        [
                                          item.lastRun
                                            ? _c("div", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm.runField(
                                                        item.lastRun,
                                                        "status"
                                                      ) || "-"
                                                    ) +
                                                    " at " +
                                                    _vm._s(
                                                      _vm.formatDate(
                                                        _vm.runField(
                                                          item.lastRun,
                                                          "finishedAt"
                                                        )
                                                      )
                                                    ) +
                                                    " "
                                                ),
                                              ])
                                            : _c("div", [_vm._v("-")]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.nextRunAtUtc`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-caption" },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.formatDate(item.nextRunAtUtc)
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.actions`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            color: "#006c27",
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openEdit(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-pencil-outline")]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            icon: "",
                                            small: "",
                                            color: "#006c27",
                                            loading:
                                              _vm.runLoadingById[item.jobId] ===
                                              true,
                                          },
                                          on: {
                                            click: function ($event) {
                                              return _vm.openRunDialog(item)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "v-icon",
                                            { attrs: { small: "" } },
                                            [_vm._v("mdi-play-circle-outline")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                          _c("v-divider", { staticClass: "my-6" }),
                          _c("div", { staticClass: "text-subtitle-2 mb-3" }, [
                            _vm._v("Admin Change Audit (latest 50)"),
                          ]),
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.auditHeaders,
                              items: _vm.auditItems,
                              loading: _vm.auditLoading,
                              "item-key": "id",
                              "item-class": () => "audit-row-clickable",
                              "items-per-page": 10,
                            },
                            on: { "click:row": _vm.openAuditDetails },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: `item.at`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-caption" },
                                        [
                                          _vm._v(
                                            _vm._s(_vm.formatDate(item.at))
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                                {
                                  key: `item.reason`,
                                  fn: function ({ item }) {
                                    return [
                                      _c(
                                        "div",
                                        { staticClass: "text-caption" },
                                        [_vm._v(_vm._s(item.reason || "-"))]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              true
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "700" },
          model: {
            value: _vm.editDialog,
            callback: function ($$v) {
              _vm.editDialog = $$v
            },
            expression: "editDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text--secondary" }, [
                _vm._v("Edit Job Configuration"),
              ]),
              _c(
                "v-card-text",
                [
                  _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                    _vm._v(_vm._s(_vm.editForm.displayName)),
                  ]),
                  _c("div", { staticClass: "text-caption grey--text mb-4" }, [
                    _vm._v(_vm._s(_vm.editForm.description)),
                  ]),
                  _c("v-switch", {
                    attrs: { color: "#006c27", label: "Enabled" },
                    model: {
                      value: _vm.editForm.enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "enabled", $$v)
                      },
                      expression: "editForm.enabled",
                    },
                  }),
                  _c("v-text-field", {
                    attrs: {
                      label: "Interval",
                      hint: "@every 5m or 0 2 * * *",
                      "error-messages": _vm.editIntervalError
                        ? [_vm.editIntervalError]
                        : [],
                      "persistent-hint": "",
                      outlined: "",
                      dense: "",
                    },
                    model: {
                      value: _vm.editForm.interval,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "interval", $$v)
                      },
                      expression: "editForm.interval",
                    },
                  }),
                  _c("v-textarea", {
                    attrs: {
                      label: "Reason (audit, required)",
                      "error-messages": _vm.editReasonError
                        ? [_vm.editReasonError]
                        : _vm.editReasonValidationError
                        ? [_vm.editReasonValidationError]
                        : [],
                      outlined: "",
                      rows: "2",
                      "auto-grow": "",
                    },
                    model: {
                      value: _vm.editForm.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.editForm, "reason", $$v)
                      },
                      expression: "editForm.reason",
                    },
                  }),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-end" },
                    [
                      _c(
                        "v-btn",
                        {
                          staticClass: "mr-2",
                          attrs: {
                            small: "",
                            text: "",
                            color: "#006c27",
                            href: "https://pkg.go.dev/time#ParseDuration",
                            target: "_blank",
                          },
                        },
                        [_vm._v(" @every help ")]
                      ),
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            small: "",
                            text: "",
                            color: "#006c27",
                            href: "https://pkg.go.dev/github.com/robfig/cron/v3#hdr-CRON_Expression_Format",
                            target: "_blank",
                          },
                        },
                        [_vm._v(" cron help ")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  !_vm.canSaveEdit
                    ? _c(
                        "div",
                        {
                          staticClass: "text-caption grey--text text--darken-1",
                        },
                        [_vm._v(_vm._s(_vm.editActionHint))]
                      )
                    : _vm._e(),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.editLoading },
                      on: {
                        click: function ($event) {
                          _vm.editDialog = false
                        },
                      },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      class: { "action-btn-disabled": !_vm.canSaveEdit },
                      attrs: {
                        color: _vm.canSaveEdit ? "#006c27" : "#9e9e9e",
                        dark: _vm.canSaveEdit,
                        loading: _vm.editLoading,
                        disabled: !_vm.canSaveEdit,
                      },
                      on: { click: _vm.saveEdit },
                    },
                    [_vm._v(" Save ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "560" },
          model: {
            value: _vm.runDialog,
            callback: function ($$v) {
              _vm.runDialog = $$v
            },
            expression: "runDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text--secondary" }, [
                _vm._v("Run Job Now"),
              ]),
              _c(
                "v-card-text",
                [
                  _c("div", { staticClass: "text-subtitle-2 mb-3" }, [
                    _vm._v(_vm._s(_vm.runForm.displayName)),
                  ]),
                  _c("v-textarea", {
                    attrs: {
                      label: "Reason (required)",
                      "error-messages": _vm.runReasonError
                        ? [_vm.runReasonError]
                        : _vm.runReasonValidationError
                        ? [_vm.runReasonValidationError]
                        : [],
                      outlined: "",
                      rows: "3",
                      "auto-grow": "",
                    },
                    model: {
                      value: _vm.runForm.reason,
                      callback: function ($$v) {
                        _vm.$set(_vm.runForm, "reason", $$v)
                      },
                      expression: "runForm.reason",
                    },
                  }),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  !_vm.canRunNow
                    ? _c(
                        "div",
                        {
                          staticClass: "text-caption grey--text text--darken-1",
                        },
                        [_vm._v(_vm._s(_vm.runActionHint))]
                      )
                    : _vm._e(),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "", disabled: _vm.runSubmitLoading },
                      on: { click: _vm.closeRunDialog },
                    },
                    [_vm._v("Cancel")]
                  ),
                  _c(
                    "v-btn",
                    {
                      class: { "action-btn-disabled": !_vm.canRunNow },
                      attrs: {
                        color: _vm.canRunNow ? "#006c27" : "#9e9e9e",
                        dark: _vm.canRunNow,
                        loading: _vm.runSubmitLoading,
                        disabled: !_vm.canRunNow,
                      },
                      on: { click: _vm.confirmRunNow },
                    },
                    [_vm._v(" Run ")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "980" },
          model: {
            value: _vm.auditDialog,
            callback: function ($$v) {
              _vm.auditDialog = $$v
            },
            expression: "auditDialog",
          },
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "text--secondary" }, [
                _vm._v("Audit Details"),
              ]),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Job:")]),
                        _vm._v(" " + _vm._s(_vm.auditSelected.jobId || "-")),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Action:")]),
                        _vm._v(" " + _vm._s(_vm.auditSelected.action || "-")),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("Actor:")]),
                        _vm._v(" " + _vm._s(_vm.auditSelected.actor || "-")),
                      ]),
                      _c("v-col", { attrs: { cols: "12", md: "6" } }, [
                        _c("strong", [_vm._v("At:")]),
                        _vm._v(
                          " " + _vm._s(_vm.formatDate(_vm.auditSelected.at))
                        ),
                      ]),
                      _c("v-col", { attrs: { cols: "12" } }, [
                        _c("strong", [_vm._v("Reason:")]),
                        _vm._v(" " + _vm._s(_vm.auditSelected.reason || "-")),
                      ]),
                    ],
                    1
                  ),
                  _c("div", { staticClass: "text-subtitle-2 mb-2" }, [
                    _vm._v("Changed fields"),
                  ]),
                  _vm.auditDiffRows.length === 0
                    ? _c(
                        "v-alert",
                        { attrs: { type: "info", outlined: "", dense: "" } },
                        [_vm._v(" No field-level differences detected. ")]
                      )
                    : _c("v-simple-table", { attrs: { dense: "" } }, [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Field")]),
                            _c("th", [_vm._v("Before")]),
                            _c("th", [_vm._v("After")]),
                          ]),
                        ]),
                        _c(
                          "tbody",
                          _vm._l(_vm.auditDiffRows, function (row) {
                            return _c("tr", { key: row.field }, [
                              _c("td", [_vm._v(_vm._s(row.field))]),
                              _c("td", { staticClass: "text-caption" }, [
                                _vm._v(_vm._s(row.before)),
                              ]),
                              _c("td", { staticClass: "text-caption" }, [
                                _vm._v(_vm._s(row.after)),
                              ]),
                            ])
                          }),
                          0
                        ),
                      ]),
                  _c(
                    "v-row",
                    { staticClass: "mt-4" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.auditBeforePretty,
                              label: "Before JSON",
                              outlined: "",
                              readonly: "",
                              "auto-grow": "",
                              rows: "8",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "12", md: "6" } },
                        [
                          _c("v-textarea", {
                            attrs: {
                              value: _vm.auditAfterPretty,
                              label: "After JSON",
                              outlined: "",
                              readonly: "",
                              "auto-grow": "",
                              rows: "8",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      attrs: { text: "" },
                      on: {
                        click: function ($event) {
                          _vm.auditDialog = false
                        },
                      },
                    },
                    [_vm._v("Close")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }